import PropTypes from 'prop-types';
import { CALYPSO } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UISlider from 'UIComponents/input/UISlider';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getFormattedTime = milliseconds => {
  const momentPlaybackTime = I18n.moment(0).hours(0).minutes(0).second(0).milliseconds(milliseconds);
  return momentPlaybackTime.hours() > 0 ? momentPlaybackTime.format('H:mm:ss') : momentPlaybackTime.format('m:ss');
};
export const getPercentageTimeRemaining = (currentTime, totalTime) => {
  return currentTime / totalTime * 100;
};
const NoWrap = styled.div.withConfig({
  displayName: "CallRecordingPlayer__NoWrap",
  componentId: "sc-157e40p-0"
})(["white-space:nowrap;"]);
const CallRecordingPlayer = ({
  currentPlaybackTime,
  duration,
  isPaused,
  canSeek,
  isLoading,
  onPauseRecording,
  onPlayRecording,
  onSkipToTime,
  hasVoicemail
}) => {
  const LoadingMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: hasVoicemail ? 'conversations-calling-message.timeline-call-metadata.call-voicemail.loading-tooltip' : 'conversations-calling-message.timeline-call-metadata.call-recording.loading-tooltip'
  });
  const SeekingUnavailableMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: hasVoicemail ? 'conversations-calling-message.timeline-call-metadata.call-voicemail.seeking-unavailable-tooltip' : 'conversations-calling-message.timeline-call-metadata.call-recording.seeking-unavailable-tooltip'
  });
  const PlayButton = /*#__PURE__*/_jsx(UIIconButton, {
    className: "m-right-1",
    color: CALYPSO,
    "data-selenium-test": isPaused ? 'call-recording-play-button' : 'call-recording-pause-button',
    "data-test-id": isPaused ? 'call-recording-play-button' : 'call-recording-pause-button',
    disabled: isLoading,
    tooltip: isLoading && LoadingMessage,
    onClick: isPaused ? onPlayRecording : onPauseRecording,
    use: "link",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: isPaused ? 'playerPlay' : 'playerPause'
    })
  });
  const CurrentPlaybackTime = /*#__PURE__*/_jsx(NoWrap, {
    children: getFormattedTime(currentPlaybackTime)
  });
  const Duration = /*#__PURE__*/_jsx(NoWrap, {
    children: getFormattedTime(duration)
  });
  const Slider = /*#__PURE__*/_jsx(UITooltip, {
    disabled: !isLoading && canSeek,
    title: isLoading ? LoadingMessage : SeekingUnavailableMessage,
    "data-test-id": "call-recording-player-slider-tooltip",
    children: /*#__PURE__*/_jsx(UISlider, {
      "data-test-id": "call-recording-player-slider",
      className: "width-100 m-right-4 m-left-6 m-top-1",
      disabled: isLoading || !canSeek,
      max: 100,
      min: 0,
      step: 1,
      onChange: onSkipToTime,
      value: getPercentageTimeRemaining(currentPlaybackTime, duration)
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "align-center width-100 justify-between display-inline-flex",
    "data-test-id": "call-recording-player",
    children: [PlayButton, CurrentPlaybackTime, Slider, Duration]
  });
};
CallRecordingPlayer.propTypes = {
  currentPlaybackTime: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  isPaused: PropTypes.bool.isRequired,
  onPauseRecording: PropTypes.func.isRequired,
  onPlayRecording: PropTypes.func.isRequired,
  onSkipToTime: PropTypes.func.isRequired,
  canSeek: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasVoicemail: PropTypes.bool
};
export default CallRecordingPlayer;